"use strict";
/* tslint:disable:no-unnecessary-type-assertion */
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleFile = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var connected_react_router_1 = require("connected-react-router");
var Types = require("types");
var viewport_1 = require("reducers/viewport");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var actions = require("@caddigital/sok-reducers/lib/actions/revisions");
var filesActions = require("@caddigital/sok-reducers/lib/actions/files");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var fileUploadModal_1 = require("actions/fileUploadModal");
var FileList_1 = require("views/FileListOverview/FileList");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var sort_1 = require("utils/sort");
var ListHeader_1 = require("views/FileListOverview/FileList/ListHeader");
var ListRow_1 = require("views/FileListOverview/FileList/ListRow");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
require("./style.scss");
var moment = require("moment");
var mapStateToProps = function (state) { return ({
    folderPath: state.files.folderPath,
    currentFolder: state.files.currentFolder,
    status: state.files.data.status,
    revisions: state.revisions,
    isMobile: (0, viewport_1.isMobile)(state.viewport),
    metadata: state.files.metadata
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    moveTo: function (url) { return dispatch((0, connected_react_router_1.push)(url)); },
    goBack: function () { return dispatch((0, connected_react_router_1.goBack)()); },
    fetchRevisions: function (revisionUUID) {
        return dispatch(actions.fetchRequest(revisionUUID, 'MINIMAL'));
    },
    onSetColumnFilter: function (key, value) {
        return dispatch(actions.setColumnFilterString(key, value));
    },
    order: function (orderBy, order) {
        return dispatch(actions.setOrder(order, orderBy));
    },
    select: function (items, status) {
        return dispatch(actions.toggleSelect(items, status));
    },
    clear: function () { return dispatch(actions.clear()); },
    removeLatestRevision: function (revision) {
        return dispatch(actions.deleteLatestRevisionRequest(revision.uuid));
    },
    uploadNewRevision: function (revision) {
        dispatch(fileUploadModal_1.default.setFileUploadModalDescription((0, translation_1.getLocalization)('fileUploadModal/description/generic')));
        dispatch(fileUploadModal_1.default.toggleModalStatus(revision.file));
    },
    convert: function (revision) {
        return dispatch(filesActions.generatePreviewRequest(revision.uuid));
    },
    navigateTo: function (url) { return dispatch((0, connected_react_router_1.push)(url)); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var toggleFile = function (props) { return function (item) {
    var fileIsSelected = props.revisions.selected.find(function (file) { return file.id === item.id; });
    if (fileIsSelected) {
        props.select([item], false);
    }
    else {
        props.select([item], true);
    }
}; };
exports.toggleFile = toggleFile;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('RevisionListView'), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('metaDataColumns', 'setMetaDataColumns', []), (0, recompose_1.withState)('files', 'setFiles', []), (0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var fileUUID = this.props.match.params.fileId;
        this.props.fetchRevisions(fileUUID);
        var columns = (this.props.metadata.status === 'FETCHED' ? this.props.metadata.list : []).sort(function (a, b) { return a.order - b.order; });
        this.props.setMetaDataColumns(columns);
        this.props.setFiles(this.props.revisions.list);
    },
    componentWillUnmount: function () {
        this.props.clear();
    },
    componentWillReceiveProps: function (nextProps) {
        var fileUUID = this.props.match.params.fileId;
        var nextFileUUID = nextProps.match.params.fileId;
        if (fileUUID !== nextFileUUID) {
            this.props.fetchRevisions(nextFileUUID);
        }
        if (this.props.currentProject !== nextProps.currentProject ||
            (this.props.metadata.status !== 'FETCHED' &&
                nextProps.metadata.status === 'FETCHED')) {
            var columns = (nextProps.metadata.status === 'FETCHED' ? nextProps.metadata.list : []).sort(function (a, b) { return a.order - b.order; });
            nextProps.setMetaDataColumns(columns);
        }
        if (this.props.revisions.list !== nextProps.revisions.list ||
            this.props.revisions.sortByOptions !== nextProps.revisions.sortByOptions) {
            var opts = nextProps.revisions.sortByOptions;
            // visible columns
            var columns_1 = nextProps.metaDataColumns.reduce(function (prev, curr) {
                prev[curr.id] = curr;
                return prev;
            }, {});
            var copy = nextProps.revisions.list.slice(0, nextProps.revisions.list.length);
            var filtered = copy;
            var filters_1;
            if (nextProps.revisions.sortByOptions.filters &&
                (filters_1 = Object.entries(nextProps.revisions.sortByOptions.filters))
                    .length > 0) {
                filtered = filtered.filter(function (f) {
                    return filters_1.reduce(function (prev, current) {
                        var key = current[0], value = current[1];
                        var column = columns_1[key];
                        if (prev === false) {
                            return false;
                        }
                        if (value && value.value && column && f.customMeta[key]) {
                            if (column.type === 'text') {
                                return (f.customMeta[key] || '')
                                    .toLowerCase()
                                    .includes(value.value.toLowerCase());
                            }
                            if (column.type === 'day') {
                                return (moment(new Date(f.customMeta[key]), 'L').format('L') === value.value.format('L'));
                            }
                            if (column.type === 'datetime') {
                                return (moment(new Date(f.customMeta[key]), 'L HH:mm').format('L HH:mm') === value.value.format('L HH:mm'));
                            }
                            if (column.type === 'select') {
                                return value.value.value === f.customMeta[key];
                            }
                            return value.value === f.customMeta[key];
                        }
                        return false;
                    }, true);
                });
            }
            var sorted = filtered;
            if (nextProps.revisions.sortByOptions.sortBy &&
                nextProps.revisions.sortByOptions.sortBy !== '') {
                var filter = nextProps.metadata.list.find(function (x) { return x.id === nextProps.revisions.sortByOptions.sortBy; });
                if (filter) {
                    sorted = filtered.sort((0, sort_1.sortFoldersAndFiles)(filter)(nextProps.revisions.sortByOptions.order || 'asc'));
                }
            }
            else {
                var meta = nextProps.metaDataColumns.find(function (c) { return c.identifier === 'name-meta'; });
                if (meta) {
                    sorted = filtered.sort((0, sort_1.sortFoldersAndFiles)(meta)('asc'));
                }
            }
            var slice = sorted.slice(Math.max(0, Math.min(sorted.length, nextProps.revisions.sortByOptions.offset)), Math.min(nextProps.revisions.sortByOptions.offset +
                nextProps.revisions.sortByOptions.limit, sorted.length));
            var final = slice;
            nextProps.setFiles(final);
        }
    }
}), recompose_1.pure);
var allowedFileFormats = ['DWG', 'PDF'];
var canCompare = function (selected) {
    if (selected.length !== 2) {
        return false;
    }
    return allowedFileFormats.some(function (type) { return selected[0].type === type && selected[1].type === type; });
};
var compareButton = function (props) {
    return (React.createElement(sok_ui_1.Button, { color: 'blue', disabled: !canCompare(props.revisions.selected), text: (0, translation_1.getLocalization)('userfront/revisionList/compare'), onClick: function () {
            if (props.currentProject) {
                if (props.revisions.selected[0] && props.revisions.selected[1]) {
                    props.moveTo("/".concat((0, translate_1.getLanguage)() || 'en', "/projects/").concat(props.currentProject.id, "/files/").concat(props.revisions.selected[0].parent, "/compare/").concat(props.revisions.selected[0].uuid, "/").concat(props.revisions.selected[1].uuid));
                }
            }
        } }));
};
exports.default = enhance(function (props) {
    var latest = props.revisions.list.length > 0 ? props.revisions.list[0] : undefined;
    var allSelected = props.revisions.selected.length > 0 &&
        props.revisions.list.length === props.revisions.selected.length;
    return (React.createElement("div", { className: 'content-wrapper-content' },
        React.createElement("div", { className: 'revision-list-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(props.BreadCrumb, { filtering: 'NONE', navigateTo: props.navigateTo, path: props.folderPath, currentProject: props.currentProject, searchResultsToggled: false }, !props.isMobile && React.createElement("span", null, latest ? latest.name : '')),
                React.createElement("h3", null,
                    React.createElement(Icon_1.Icon, { className: 'fa-history', prefix: 'far' }),
                    ' ',
                    (0, translation_1.getLocalization)('userfront/revisionList/header')),
                React.createElement("div", { className: 'tools' },
                    React.createElement(sok_ui_1.Button, { icon: React.createElement(Icon_1.Icon, { className: 'fa-cloud-upload' }), color: 'green', disabled: props.revisions.list.length === 0, text: (0, translation_1.getLocalization)('userfront/revisionList/uploadRevision'), onClick: function () {
                            if (props.revisions.list.length > 0) {
                                props.uploadNewRevision(props.revisions.list[0]);
                            }
                        } }),
                    React.createElement(sok_ui_1.Button, { icon: React.createElement(Icon_1.Icon, { className: 'fa-trash' }), color: 'red', disabled: props.revisions.list.length < 1, onClick: function () {
                            if (props.revisions.list.length > 1) {
                                props.setIsOpen(true);
                            }
                        }, text: (0, translation_1.getLocalization)('userfront/revisionList/deleteLatestRevision') })),
                React.createElement("div", { className: 'list' },
                    React.createElement(sok_ui_1.RequestStatusBox, { status: props.revisions.deleteStatus, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                        React.createElement("span", null, (0, translation_1.getLocalization)('userfront/revisionList/delete/deleting')),
                        React.createElement("span", null, (0, translation_1.getLocalization)('userfront/revisionList/delete/deleted')),
                        React.createElement("span", null, (0, translation_1.getLocalization)('userfront/revisionList/delete/error'))),
                    (function () {
                        switch (props.revisions.status) {
                            case 'FETCHED':
                                if (!props.currentFolder) {
                                    return (React.createElement("div", { className: 'loading' },
                                        React.createElement(sok_ui_1.LoadingSpinner, null)));
                                }
                                var splitted = props.baseUrl.split('/');
                                var baseUrl = splitted
                                    .slice(0, splitted.length - 2)
                                    .join('/');
                                return (React.createElement(FileList_1.FileList, { hideHeaderDownload: true, key: 'list', ListHeader: ListHeader_1.ListHeader, ListRow: ListRow_1.ListRow, isMobile: props.isMobile, baseUrl: baseUrl, currentFolder: props.currentFolder, items: props.files, sortByOptions: props.revisions.sortByOptions, convert: props.convert, downloadFolder: function () {
                                        /** */
                                    }, isAllBookmarked: false, onBookmarkClick: function () {
                                        /** */
                                    }, onUnBookmarkClick: function () {
                                        /** */
                                    }, onBookmarkAllFiles: function () {
                                        /** */
                                    }, toggleItem: (0, exports.toggleFile)(props), onSelectAll: function () {
                                        return props.select(props.revisions.list, !allSelected);
                                    }, itemSelections: props.revisions.selected, sortBy: function (col, order) { return props.order(col, order); }, isAllSelected: allSelected, metaDataColumns: props.metaDataColumns, onSetColumnFilter: props.onSetColumnFilter, navigateTo: props.navigateTo, openNotificationsMenu: function () {
                                        /** */
                                    }, token: '', hideActions: true, hideDownload: false }));
                            case 'FETCHING':
                                return (React.createElement("div", { className: 'loading' },
                                    React.createElement("div", null,
                                        React.createElement(sok_ui_1.LoadingSpinner, null))));
                            default:
                                return React.createElement(GenericErrorMessage_1.default, null);
                        }
                    })()),
                React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.isOpen, close: function () { return props.setIsOpen(false); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                        React.createElement(ConfirmDialog_1.Exclamation, null),
                        React.createElement("div", null,
                            React.createElement("div", { className: 'title please-confirm-text' },
                                React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                            React.createElement("div", { className: 'text' },
                                React.createElement("p", null, (0, translation_1.getLocalization)('userfront/revisionList/remove/areYouSure'))))), footer: React.createElement(React.Fragment, null,
                        React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                                props.removeLatestRevision(props.revisions.list[0]);
                                props.setIsOpen(false);
                            } }),
                        React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setIsOpen(false); } })) }),
                React.createElement(sok_ui_1.Footer, null,
                    (function () {
                        if (props.currentProject) {
                            var perm = 0x00;
                            if (props.revisions.selected.length === 2) {
                                if (props.revisions.selected[0].type === 'PDF' ||
                                    props.revisions.selected[1].type === 'PDF') {
                                    perm |= acl.PDFCOMPARE_PERM;
                                }
                                if (props.revisions.selected[0].type === 'DWG' ||
                                    props.revisions.selected[1].type === 'DWG') {
                                    perm |= acl.VIEWER_2D_PERM;
                                }
                            }
                            if (props.currentProject.perm & perm) {
                                if (canCompare(props.revisions.selected)) {
                                    return compareButton(props);
                                }
                                else {
                                    return (React.createElement(sok_ui_1.Tooltip, { tipPosition: 'topcenter', content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/revisionList/cannotcompare')) }, compareButton(props)));
                                }
                            }
                        }
                        return null;
                    })(),
                    React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/revisionList/close'), onClick: function () { return props.goBack(); } }))))));
});
